<div class="container greyTextContainer">
  <h1>Sent!</h1>
  <br />

  <p style="text-align: left">
    Please check your email. A link to your service agreement has been sent to
    your inbox. Click on the link and digitally sign the service agreement. A
    signed copy will be sent to you and to ADIEM.
  </p>

  <button class="okBtn" mat-raised-button type="button" (click)="back()">
    Ok
  </button>
</div>
